import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed';

const Creatives = {
  Helmet: lazy(() => import('./components/Helmet')),
  RoleBasedRedirector: lazy(() => import('./components/RoleBasedRedirector')),
  Digital: {
    CreativesList: lazyNamed(() => import('./containers/Digital/containers/CreativesList'), 'CreativesList'),
    CreativeForm: lazy(() => import('./containers/Digital/containers/CreativePage')),
    BulkUploadNative: lazyNamed(() => import('./containers/Digital/containers/BulkUploadNative'), 'BulkUploadNative'),
    Providers: lazyNamed(() => import('./containers/Digital/components/Providers'), 'Providers'),
  },
  Print: {
    CreativesList: lazyNamed(() => import('./containers/Print/containers/CreativesList'), 'CreativesList'),
    CreativeForm: lazy(() => import('./containers/Print/containers/CreativeFormPage')),
  },
  AdServer: {
    CreativesList: lazyNamed(() => import('./containers/AdServer/containers/CreativesList'), 'CreativesList'),
    CreativeDetails: lazy(() => import('./containers/AdServer/containers/CreativeDetails')),
  },
  Templates: {
    TemplatesList: lazyNamed(() => import('./containers/Templates'), 'TemplatesList'),
    TemplateForm: lazyNamed(() => import('./containers/Templates'), 'TemplateForm'),
  },
};

export default Creatives;
